import "../../../css/product-cards.scss";
import "../../../css/ribbon-labels.scss";
import { AutoFormatNumber } from '../../Helpers/FormatNumber';
import { DataLayerModelFactory } from "../../Services/DataLayer/DataLayerEvents";
import AddToCartVM from "./Components/AddToCart";
import { KnockoutValidationSettings } from "../../Globals/KnockoutValidationSettings";

export class SectionVM {
    private AddToCart = AddToCartVM.AddToCart;
    private FormatNumber = AutoFormatNumber;
    private ApprovalType = new AddToCartVM().ApprovalType;
    private SelectedApprover = new AddToCartVM().SelectedApprover;
    private SelectApprover = new AddToCartVM().SelectApprover;
    private ContractPricingLevels = new AddToCartVM().ContractPricingLevels
    private AddressBook = new AddToCartVM().AddressBook;
    private Comment = new AddToCartVM().RestrictionComment;
    private CustName = new AddToCartVM().CustName;
    private CustPhone = new AddToCartVM().CustPhone;
    private CustEmail = new AddToCartVM().CustEmail;
    private AltItemsHtml = AddToCartVM.AltItemsHtml;
    private RestrictionItems = new AddToCartVM().RestrictionItems;
    private ShowRetrictionModal = new AddToCartVM().ShowRetrictionModal;

    constructor() {
        ko.validation.init(KnockoutValidationSettings, true);

        let self = this;

        //events: ref. jquery on click events(add to contract)
        AddToCartVM.EventListeners(self);

        // Analytics data layer implementation
        $(() => {

            if (window.location.pathname === "/") {
                return;
            }

            let productsModel: Array<any> = window.Model?.FilterResult || [];

            let dataLayerItems = productsModel.filter((item) => {
                return item.SingleItemID;
            });

            let products = [];

            if (dataLayerItems.length) {
                products = dataLayerItems.map(function (obj, index) {
                    return {
                        brand: obj.VendName,
                        id: obj.SingleItemID || obj.DisplayItemID,
                        name: obj.Heading,
                        price: obj.LowestPrice,
                        variant: obj.DisplayUMQty,
                        position: index
                    }
                })
            }

            let analytics = new DataLayerModelFactory().impressions(products, "productView", "Section Group Product View");

            if (analytics.ecommerce.impressions.length) {
                window.dataLayer.push(analytics);
            }

            $('.fa-cart-plus').parent().on('click', function () {
                let itemID = $(this).attr('data-itemid');

                let product = products.find(function (singleItem) {
                    return singleItem.id === itemID;
                });

                product.quantity = 1;
                console.debug("dataLayer product:", product);
                window.dataLayer.push(new DataLayerModelFactory().addToCart(product));
            });

        })
    }
}